import TitleDetail from './TitleDetail';

export default TitleDetail;
